import React, { useMemo } from "react";
import { Typography } from "@material-ui/core";
import { formatDate } from "../../../utils/formatDate";

type Props = {
  title?: string;
  from: string;
  to: string | null;
  variant?: string;
};

export const DateRangeLabel: React.FC<Props> = ({
  title,
  from,
  to,
  variant,
}) => {
  const label = useMemo(() => {
    const fromDt = formatDate(from);
    const toDt = !to ? "onwards" : `to ${formatDate(to)}`;
    return title ? `${title}: ${fromDt} ${toDt}` : `${fromDt} ${toDt}`;
  }, [from, title, to]);
  return (
    <Typography
      component="span"
      variant={(variant || "body2") as any}
      color="textPrimary"
    >
      {label}
    </Typography>
  );
};
